// extracted by mini-css-extract-plugin
export var dropdownButton = "_3o-0";
export var fullWidthDropdownButton = "_3o-1";
export var icon = "_3o-3";
export var iconPlaceholder = "_3o-2";
export var menuItemRow = "_3o-5";
export var shortcutContainer = "_3o-4";